export default __webpack_public_path__ + "static/media/welcomeImage_1_PROD.b661bb3a.jpg";